

export interface NaviBarProps {
  title?: string
  titleKey?: string
  placeholderKey?: string
  showAdd: boolean
  titleAlign?: TextAlign
  backIcon?: string
}

export interface NaviBarEmit {
  (evt: "tapadd"): void
}
export type TextAlign = "left" | "center" | "right"
export const naviBarProps = {
  title: {
    type: String,
  },
  titleKey: {
    type: String,
  },
  placeholderKey: {
    type: String,
  },
  showAdd: {
    type: Boolean,
    default: false,
  },
  titleAlign: {
    type: String as () => TextAlign,
    default: "left",
  },
  backIcon: {
    type: String,
    default: "arrow-back700",
  }
}
